export default {
  exhibitions: 'Exhibitions',
  public_exhibitions: 'Shared exhibitions',
  my_exhibitions: 'Mine exhibitions',
  add_edit_exhibition: 'Create / edit exhibition',
  login_required: 'You must log in to create and edit exhibitionss',
  help_public:
    'The Exhibitions module serves as a virtual curation tool: it allows you to select illustrations from the e-illustration database and assemble them into your own thematic units. Users can link illustrations across titles, add their own comments, and use them for presentation, study, and ongoing collection of material. To create exhibitions, you must <button1>login</button1>. For more detailed information and procedures, see <button2>help</button2>.',
  help_logged_in:
    'The Exhibitions module serves as a virtual curation tool: it allows you to select illustrations from the e-illustration database and assemble them into your own thematic units. Users can link illustrations across titles, add their own comments, and use them for presentation, study, and ongoing collection of material. For more detailed information and procedures, see <button2>help</button2>.',
  exhibitions_shown: 'Exhibitions shown {{count}}',
  add_exhibition: 'Add exhibition',
  new_exhibition: 'New exhibition',
  how_to_use_exhibitions: 'How to use exhibitions tool?',
  discard_changes: 'Discard changes',
  save_and_display: 'Save and display',
  save_exhibtion: 'Save exhibition',
  edit_exhibition: 'Edit exhibition',
  delete_exhibition: 'Delete exhibition',
  name_of_exhibition: 'Name of exhibition',
  introduction: 'Introduction (optional – maximum 750 characters)',
  type_of_exhibition_view: 'Type of exhibition view',
  album: 'Album',
  storyline: 'Storyline',
  slider: 'Slider',
  add_illustration: 'Add illustration',
  illustrations: 'illustrations',
  search_illustration: 'Search illustration',
  search_placeholder:
    'Start writing the name of art to quickly add it to your exhbition',
  from_selection: 'From my selection',
  add_description: 'Add description',
  unsaved_changes: 'Your changes were not saved for {{count}} minutes',
  did_not_found: 'Did not find what you were looking for?',
  go_to_artwork_search: 'Go to the artwork search and explore artists',
  objects_and_more: ', objects and more.',
  dont_forget_to_save: "Don't forget to save your illustration",
  add_from_selection: 'Add Illustration from my selection',
  empty_selection: 'Your selection is empty',
  add_to_exhibition: 'Add to exhibition',
  headline: 'Headline (optional)',
  year: 'Year (optional)',
  custom_title: 'Add a title to display the story and preview',
  custom_date: 'Add your own date to view the story',
  published: 'Published',
  private: 'Private',
  featured_artists: 'Artists featured in this exhibition: ',
  artworks: 'Number of illustrations: ',
  explore_artists: 'Explore the artists in this exhibition: ',
  remove_from_exhibition: 'Remove from exhibition',
  year_title: 'year',
  saving_exhibition: 'Saving of exhibition is in progress',
  exhibition_saved_successfully: 'Exhibition was saved successfully',
  error_when_saving_exhibition: 'Error occurred when saving exhibition',
  exhibition_not_found: 'Exhibition not found',
  exhibition_deleted: 'Exhibition was deleted',
  deletion_in_progress: 'Deletion in progress',
  deletion_error: 'Error occurred when deleting exhibition',
  publicity_changing: 'Publicity change in progress',
  publicity_changed: 'Publicity was changed successfully',
  publicity_change_error: 'Error occurred when changing publicity',
  go_to_complex_search: 'Go to advanced search',
  and_use_my_selection: ' and use the My Selection function.',
  in_book: 'In book: ',
  author: 'Author: ',
  user_name: 'Exhibition author: ',
  featured_books: 'Featured books: ',
  created: 'Created: ',
  inactivity_modal_header: 'Warning',
  inactivity_modal_text:
    'Your changes have not been saved for more than 15 minutes',
  inactivity_modal_button: 'Close',
  default_illustration: 'Default illustration',
  set_default_illustration: 'A default illustration must be set',
  editor_bold: 'Bold',
  editor_italic: 'Italic',
  editor_underline: 'Underline',
  editor_blockquote: 'Quote',
  editor_heading_1: 'Heading 1',
  editor_heading_2: 'Heading 2',
  editor_bullet_list: 'Bullet list',
  editor_ordered_list: 'Ordered list',
  editor_block_format: 'Block format',
  editor_normal: 'Normal',
  editor_color: 'Color',
  editor_text_color: 'Text color',
  editor_default_color: 'Default',
  editor_color_red: 'Red',
  editor_color_blue: 'Blue',
  editor_color_green: 'Green',
  editor_color_warning: 'Orange',
  editor_custom_color: 'Custom color',
  editor_link: 'Link',
  editor_link_prompt: 'Link URL',
  editor_apply_link: 'Apply link',
  editor_remove_link: 'Remove link',
  editor_cancel_link: 'Cancel',
  editor_clear_formatting: 'Clear formatting',
}
